
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

const PolitiqueConfidentialitePage = () => {
  return (
    <>
      <header>
        <h1 className="sr-only">Politique de confidentialité - SARL ADF Biomédical Algérie</h1>
      </header>
      <Navbar />
      <main>
        {/* HERO SECTION */}
        <section className="relative pt-32 pb-20 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center"
            >
              <p className="text-sm text-text-secondary mb-6">
                <Link to="/" className="hover:text-[#E31B23] transition-colors cursor-pointer">Accueil</Link> / Politique de confidentialité
              </p>
              <h2 className="text-5xl md:text-6xl font-bold text-text-primary mb-6">
                Politique de confidentialité
              </h2>
              <p className="text-xl text-text-secondary max-w-3xl mx-auto">
                Protection de vos données personnelles
              </p>
            </motion.div>
          </div>
        </section>

        {/* CONTENU */}
        <section className="py-24 bg-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="space-y-12"
            >
              {/* Introduction */}
              <div>
                <div className="bg-gray-50 rounded-xl p-8">
                  <p className="text-base text-text-secondary leading-relaxed mb-4">
                    SARL ADF Biomédical accorde une grande importance à la protection de vos données personnelles. Cette politique de confidentialité vous informe sur la manière dont nous collectons, utilisons, stockons et protégeons vos informations personnelles conformément à la législation algérienne (Loi n° 18-07 du 10 juin 2018 relative à la protection des personnes physiques dans le traitement des données à caractère personnel) et au Règlement Général sur la Protection des Données (RGPD).
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    <strong className="text-text-primary">Date de dernière mise à jour :</strong> Janvier 2025
                  </p>
                </div>
              </div>

              {/* Responsable du traitement */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-shield-user-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Responsable du traitement des données
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    <strong className="text-text-primary">Responsable :</strong> SARL ADF Biomédical
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    <strong className="text-text-primary">Adresse :</strong> Local N01 Benghazi N16, Baraki, Alger, Algérie
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    <strong className="text-text-primary">Email :</strong> contact@adfbiomedical.dz
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    <strong className="text-text-primary">Téléphone :</strong> +213 770 30 79 05
                  </p>
                </div>
              </div>

              {/* Données collectées */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-database-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Données personnelles collectées
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-6">
                  <div>
                    <h4 className="text-xl font-bold text-text-primary mb-3">Données d'identification</h4>
                    <ul className="space-y-2">
                      <li className="flex items-start text-base text-text-secondary">
                        <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                        Nom et prénom
                      </li>
                      <li className="flex items-start text-base text-text-secondary">
                        <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                        Adresse email
                      </li>
                      <li className="flex items-start text-base text-text-secondary">
                        <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                        Numéro de téléphone
                      </li>
                      <li className="flex items-start text-base text-text-secondary">
                        <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                        Nom de l'établissement
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-text-primary mb-3">Données de navigation</h4>
                    <ul className="space-y-2">
                      <li className="flex items-start text-base text-text-secondary">
                        <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                        Adresse IP
                      </li>
                      <li className="flex items-start text-base text-text-secondary">
                        <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                        Type de navigateur
                      </li>
                      <li className="flex items-start text-base text-text-secondary">
                        <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                        Pages visitées
                      </li>
                      <li className="flex items-start text-base text-text-secondary">
                        <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                        Date et heure de connexion
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Finalités */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-target-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Finalités du traitement
                </h3>
                <div className="bg-gray-50 rounded-xl p-8">
                  <p className="text-base text-text-secondary leading-relaxed mb-4">
                    Vos données personnelles sont collectées et traitées pour les finalités suivantes :
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      Traitement de vos demandes de contact et de renseignements
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      Gestion de la relation client et suivi des commandes
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      Envoi d'informations sur nos produits et services (avec votre consentement)
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      Amélioration de nos services et de notre site web
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      Respect de nos obligations légales et réglementaires
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      Statistiques et analyses de fréquentation du site
                    </li>
                  </ul>
                </div>
              </div>

              {/* Base légale */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-scales-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Base légale du traitement
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    Le traitement de vos données personnelles repose sur les bases légales suivantes :
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Votre consentement</strong> pour l'envoi de communications commerciales
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">L'exécution d'un contrat</strong> pour la gestion de vos commandes
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Le respect d'obligations légales</strong> (comptabilité, fiscalité)
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Notre intérêt légitime</strong> pour l'amélioration de nos services
                    </li>
                  </ul>
                </div>
              </div>

              {/* Durée de conservation */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-time-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Durée de conservation des données
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    Vos données personnelles sont conservées pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées :
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Données de contact :</strong> 3 ans à compter du dernier contact
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Données de commande :</strong> 10 ans (obligations comptables et fiscales)
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Données de navigation :</strong> 13 mois maximum
                    </li>
                  </ul>
                </div>
              </div>

              {/* Destinataires */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-group-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Destinataires des données
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    Vos données personnelles sont destinées aux services internes de SARL ADF Biomédical. Elles peuvent également être transmises à :
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      Nos prestataires techniques (hébergement, maintenance)
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      Nos partenaires logistiques pour la livraison
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      Les autorités compétentes en cas d'obligation légale
                    </li>
                  </ul>
                  <p className="text-base text-text-secondary leading-relaxed mt-4">
                    Nous nous assurons que ces tiers respectent la confidentialité et la sécurité de vos données personnelles.
                  </p>
                </div>
              </div>

              {/* Vos droits */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-hand-heart-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Vos droits
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed mb-4">
                    Conformément à la législation algérienne et au RGPD, vous disposez des droits suivants :
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Droit d'accès :</strong> obtenir la confirmation que vos données sont traitées et y accéder
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Droit de rectification :</strong> corriger vos données inexactes ou incomplètes
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Droit à l'effacement :</strong> demander la suppression de vos données
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Droit à la limitation :</strong> limiter le traitement de vos données
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Droit d'opposition :</strong> vous opposer au traitement de vos données
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Droit à la portabilité :</strong> recevoir vos données dans un format structuré
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Droit de retirer votre consentement :</strong> à tout moment
                    </li>
                  </ul>
                  <p className="text-base text-text-secondary leading-relaxed mt-6">
                    Pour exercer vos droits, contactez-nous à : <a href="mailto:contact@adfbiomedical.dz" className="text-[#E31B23] hover:underline cursor-pointer">contact@adfbiomedical.dz</a>
                  </p>
                </div>
              </div>

              {/* Sécurité */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-lock-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Sécurité des données
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    SARL ADF Biomédical met en œuvre toutes les mesures techniques et organisationnelles appropriées pour garantir la sécurité et la confidentialité de vos données personnelles et empêcher qu'elles ne soient déformées, endommagées ou communiquées à des tiers non autorisés.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    Nos mesures de sécurité incluent notamment :
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      Chiffrement des données sensibles
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      Accès restreint aux données personnelles
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      Sauvegardes régulières
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      Surveillance et détection des incidents de sécurité
                    </li>
                  </ul>
                </div>
              </div>

              {/* Modifications */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-refresh-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Modifications de la politique
                </h3>
                <div className="bg-gray-50 rounded-xl p-8">
                  <p className="text-base text-text-secondary leading-relaxed">
                    SARL ADF Biomédical se réserve le droit de modifier cette politique de confidentialité à tout moment. Toute modification sera publiée sur cette page avec une nouvelle date de mise à jour. Nous vous encourageons à consulter régulièrement cette page pour prendre connaissance des éventuelles modifications.
                  </p>
                </div>
              </div>

              {/* Contact */}
              <div className="bg-gradient-to-r from-[#E31B23] to-[#C41820] rounded-2xl p-12 text-center">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-white/20 rounded-full">
                  <i className="ri-question-line text-5xl text-white"></i>
                </div>
                <h4 className="text-3xl font-bold text-white mb-4">Questions sur vos données ?</h4>
                <p className="text-lg text-white/90 mb-8">
                  Notre équipe est à votre disposition pour répondre à toutes vos questions
                </p>
                <Link
                  to="/contact"
                  className="inline-block px-10 py-4 bg-white text-[#E31B23] rounded-lg font-semibold text-lg hover:bg-gray-100 transition-all duration-300 shadow-lg cursor-pointer whitespace-nowrap"
                >
                  Nous contacter
                </Link>
              </div>
            </motion.div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default PolitiqueConfidentialitePage;
